import setFieldValue from "@iewccouk/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewccouk/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    billingAddressLineOne: state.customCreateAccountForm.fieldValues.billingAddressLineOne,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const BillingAddressLineOneWidget: React.FC<Props> = ({ billingAddressLineOne, previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Address Line 1");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, billingAddressLineOne, "billingAddressLineOne", () =>
        validateFieldBy(isRequired, label, billingAddressLineOne, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "billingAddressLineOne", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={billingAddressLineOne || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingAddressLineOneWidget);
